/**
 * Scrollable list of drops to copy (stats-tab flow).
 */

import type { FC } from 'react';
import { List } from 'lucide-react';

import type { DropsWithStatsRow } from '@/features/smswiser-campaigns/types/workspace.types';

function orDash(v: string | string[] | null | undefined): string {
  if (v == null) return '—';
  if (Array.isArray(v)) return v.length ? v.join(', ') : '—';
  return String(v || '').trim() || '—';
}

export const CopyAsDraftRowsPreview: FC<{ rows: DropsWithStatsRow[] }> = ({ rows }) => (
  <div className="flex min-h-0 flex-col gap-2">
    <span className="flex items-center gap-2 text-xs font-medium text-muted-foreground">
      <List className="h-3.5 w-3.5 shrink-0" aria-hidden />
      Drop list ({rows.length})
    </span>
    <div className="max-h-[140px] min-h-0 overflow-y-auto rounded-md border border-border bg-muted/30 p-2">
      <ul className="space-y-1.5 text-xs">
        {rows.map((r) => {
          const d = r.drop;
          const leads = orDash(d.leadsList);
          const title = d.title?.trim() || leads;
          return (
            <li key={d.uniqueId} className="flex min-w-0 gap-1.5 truncate">
              <span className="shrink-0 font-mono text-muted-foreground" title={d.uniqueId}>
                {d.uniqueId}
              </span>
              <span className="min-w-0 truncate text-foreground" title={title}>
                {title}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  </div>
);
